// src/pages/HomePage.js
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import SurgeonProfile from './SurgeonProfile';
import BeforeAfterCarousel from './BeforeAfterCarousel';
import InteractiveImageComponent from './InteractiveImageComponent';
import FaceliftComparison from './FaceliftComparison';
import WhyCali from './WhyCali';
import MedicalTourism from './MedicalTourism';
import ContactImage from './ContactImage.png';
import ButtonImage from './ButtonImage.svg';
import MobileConsultationForm from './MobileConsultationForm';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import { getWhatsAppUrl } from './utils/whatsapp';
import './HomePage.css';

const images = [
    'homep.webp',
    'rio.webp',
    'col.webp',
];

function HomePage() {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isMobileView, setIsMobileView] = useState(
        () => typeof window !== 'undefined' && window.innerWidth <= 768
    );
    const { language } = useLanguage();
    const t = translations[language];
    const whatsappUrl = getWhatsAppUrl(language);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 8000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleWhatsAppClick = () => {
        window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    };

    return (
        <div>
            <Helmet>
                {language === 'ES' && (
                    <>
                        <title>Dr. Juan Salazar – Cirujano Plástico en Cali | Cirugía Plástica Colombia</title>
                        <meta name="description" content="Dr. Juan David Salazar, cirujano plástico certificado en Cali, Colombia y Río de Janeiro. Rinoplastia, lipoescultura, aumento de senos, blefaroplastia, lifting facial. Agenda tu consulta." />
                    </>
                )}
                {language === 'EN' && (
                    <>
                        <title>Dr. Juan Salazar – Plastic Surgeon Cali Colombia | Medical Tourism</title>
                        <meta name="description" content="Dr. Juan David Salazar, board-certified Plastic & Reconstructive Surgeon in Cali, Colombia and Rio de Janeiro, Brazil. Rhinoplasty, liposuction, breast augmentation, blepharoplasty, facelift. Book your consultation." />
                    </>
                )}
                {language === 'PT' && (
                    <>
                        <title>Dr. Juan Salazar – Cirurgião Plástico no Rio de Janeiro | Cirurgia Plástica</title>
                        <meta name="description" content="Dr. Juan David Salazar, cirurgião plástico e reconstrutivo certificado no Rio de Janeiro e Cali, Colômbia. Rinoplastia, lipoescultura, aumento de seios, blefaroplastia e lifting facial." />
                    </>
                )}
            </Helmet>
            <section className="App-slideshow">
                <div className="image-container">
                    {images.map((image, index) => (
                        <img
                            key={index}
                            src={image}
                            alt={`Slide ${index}`}
                            className={`fade-image ${index === currentImageIndex ? 'visible' : ''}`}
                        />
                    ))}
                    <div className="slideshow-text">
                        <p2 className="welcome-text">{t.welcome}</p2>
                        <h1 className="headline-text">
                            {t.headlinePart1} <br />{t.headlinePart2}
                        </h1>

                        <p className="subheadline-text">{t.subheadline}</p>
                        <a
                            className="book-appointment-btn"
                            href={whatsappUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {t.bookAppointment}
                        </a>
                    </div>
                </div>
            </section>

            <div className="homepage-sections">
                <div className="homepage-slot homepage-slot--surgeon">
                    <SurgeonProfile />
                </div>

                <div className="homepage-slot homepage-slot--transformations">
                    <BeforeAfterCarousel />
                </div>

                <div className="homepage-slot homepage-slot--interactive">
                    <InteractiveImageComponent />
                </div>

                <div className="homepage-slot homepage-slot--facelift">
                    <FaceliftComparison />
                </div>

                <div className="homepage-slot homepage-slot--why-cali">
                    <WhyCali />
                </div>

                <div className="homepage-slot homepage-slot--medical-tourism">
                    <MedicalTourism />
                </div>

                <div className="homepage-slot homepage-slot--contact">
                    {isMobileView ? (
                        <MobileConsultationForm />
                    ) : (
                        <div className="contact-image-container">
                            <img src={ContactImage} alt="Contact" className="contact-image" loading="lazy" />
                            <button className="whatsapp-btn" onClick={handleWhatsAppClick}>
                                <img src={ButtonImage} alt="WhatsApp Icon" className="button-image" loading="lazy" /> {t.whatsapp}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default HomePage;
